import React, {useState, useEffect} from 'react';
import './SinglePageEntry.css';
import FormColumn from '../FormColumn/FormColumn';
import TextDisplay from '../TextDisplay/TextDisplay';

const SinglePageEntry = (props) => {

const pageCss = props.fullScreen ? "singlepageentry-fullscreencontent" : "singlepageentry-content";

useEffect(() => {

    var focusFound = false;
    for (var column of props.config.Columns) {
        for (var formGroup of column.FormGroups) {
            for (var field of formGroup.Fields) {
                if (field.Type !== 'text' && field.Type !== 'date') { // 'text' is not an ipput field & .focus() doesn't work for FluentUI date-pickers currently.
                    var id = field.Id;
                    if (id !== undefined && id !== null) {
                        let doc = document.getElementById(id);
                        if (doc !== undefined && doc !== null) {
                            doc.focus();
                            focusFound = true;
                            break;
                        }
                    }
                }
            }
            if (focusFound) break;
        }
        if (focusFound) break;
    }

}, [props.config.Name]);


return (
    <div className={pageCss}>
        <div className='singlepageentry-title'>{props.config.PageTitle}</div>
        <div className='singlepageentry-headertext'>
            <TextDisplay text={props.config.Text}></TextDisplay>
        </div>
        <div>
            {props.config.Columns.map((column) => {
                return (
                    <FormColumn 
                        key={column.Key} 
                        onKeyDown={props.onKeyDown}
                        config={column} 
                        multiPage={props.config.MultiPageView} 
                        changeHandler={props.changeHandler} 
                        fieldFocusOut={props.fieldFocusOut} 
                        data={props.data} 
                        language={props.language} 
                        id={props.id}>

                        </FormColumn>
                )
            })}
        </div>
    </div>
)

};

export default SinglePageEntry;

